/**
 * Converts a whole number percentage to decimal format with 2 decimal places.
 * @example
 * convertNumberToPercentage(50) // returns 0.50
 * convertNumberToPercentage(75) // returns 0.75
 * convertNumberToPercentage(100) // returns 1.00
 *
 * To convert back to whole number:
 * 0.50 * 100 = 50
 * @param wholeNumber - The whole number percentage (e.g., 50, 75, 100)
 * @returns The decimal representation formatted to 2 decimal places
 */
export const convertNumberToPercentage = (wholeNumber?: string | number): string => {
  // if not number return wholeNumber
  const numericValue = Number(wholeNumber)
  if (isNaN(numericValue)) {
    return ''
  }
  return Number((numericValue / 100).toFixed(2)).toString()
}
